import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/Custom/GameTimeline/arrow-right-arrow-left-duotone-solid.svg";

export function ArrowRightArrowLeftDuotoneSolid(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
